import { Event } from "../../tracking";
import {
  CLEAR_ERRORS,
  CLOSE_QUIZ_ABANDON, 
  CLOSE_QUIZ_DONE, 
  LOADING_UI,
  OPEN_QUIZ, 
  SET_ERRORS,
  STOP_LOADING_UI
} from '../types';

  
  const initialState = {
    loading: false,
    errors: {}
  };
  
  export default function(state = initialState, action) {
    switch (action.type) {
      case SET_ERRORS:
        return {
          ...state,
          loading: false,
          errors: action.payload
        };
      case CLEAR_ERRORS:
        return {
          ...state,
          loading: false,
          errors: {}
        };
      case LOADING_UI:
        return {
          ...state,
          loading: true
        };
      case STOP_LOADING_UI:
        return {
          ...state,
          loading: false
        };
      case OPEN_QUIZ:
          Event("Activity", "Open Quiz", action.payload);
          return state;
      case CLOSE_QUIZ_DONE:
          Event("Activity", "Finish Quiz", action.payload);
          return state;
      case CLOSE_QUIZ_ABANDON:
          Event("Activity", "Abandon Quiz", action.payload);
          return state;
      default:
        return state;
    }
  }